import { render, staticRenderFns } from "./Annex.vue?vue&type=template&id=1da0566a&"
import script from "./Annex.vue?vue&type=script&lang=js&"
export * from "./Annex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports